/** FogVolume registration: the parser. Property knowledge for the linter lives in linterParser.ts. */
import { nodeRegistry } from '../../../core/NodeRegistry';
import { parseFogVolume } from './parser';
const fogVolumeRegistration = {
    typeName: 'FogVolume',
    parser: parseFogVolume,
};
nodeRegistry.register(fogVolumeRegistration);
export * from './parser';
export * from './types';
//# sourceMappingURL=index.js.map